export const GET_MY_VEHICLES_URL = 'idai-service/get_inscriptions';
export const GET_MY_VEHICLES_KEY = 'get-my-vehicles';
